import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form } from '@formio/react';
import firebaseService from '../services/firebaseService';
import Navigation from './Navigation';

function FormRenderer() {
  const { formId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [submission, setSubmission] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const loadForm = async () => {
    try {
      setLoading(true);
      setError('');
      const form = await firebaseService.getFormById(formId);
      setFormData(form);
    } catch (err) {
      setError('Failed to load form. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formId]);

  const handleSubmit = async (submission) => {
    console.log('Form submitted:', submission);
    setSubmitting(true);
    setError('');

    try {
      // Save the submission to Firebase
      const result = await firebaseService.saveFormAnswer(
        formId,
        formData.name || formData.title || 'Untitled Form',
        submission.data
      );
      
      console.log('Submission saved:', result);
      setSubmission(submission);
    } catch (err) {
      console.error('Error saving submission:', err);
      setError('Failed to save form submission. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleBack = () => {
    navigate('/forms');
  };

  return (
    <div className="form-renderer-container">
      <Navigation />
      
      <div className="content-wrapper">
        <div className="form-header">
          <button onClick={handleBack} className="btn-back">
            ← Back to Forms
          </button>
          {formData && <h2>{formData.name || formData.title || 'Form'}</h2>}
        </div>

      {loading && (
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading form...</p>
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
          <button onClick={loadForm} className="btn-retry">
            Retry
          </button>
        </div>
      )}

      {!loading && !error && formData && (
        <div className="form-content">
          {submission ? (
            <div className="submission-success">
              <div className="success-icon">✓</div>
              <h3>Form Submitted Successfully!</h3>
              <p>Thank you for your submission. Your answers have been saved.</p>
              <button onClick={handleBack} className="btn-primary">
                Back to Forms
              </button>
            </div>
          ) : (
            <>
              {submitting && (
                <div className="submitting-overlay">
                  <div className="spinner"></div>
                  <p>Saving your submission...</p>
                </div>
              )}
              <Form
                form={formData.schema}
                onSubmit={handleSubmit}
              />
            </>
          )}
        </div>
      )}
      </div>
    </div>
  );
}

export default FormRenderer;
